export enum FeatureFlag {
  ChatReset,
  PdfPreview,
  IncludeAllCitations,
  RemarkMath,
  RichReferences
}

const agentFeatureFlags: { [key in FeatureFlag]: string[] } = {
  [FeatureFlag.ChatReset]: ['TrafoChat'],
  [FeatureFlag.PdfPreview]: ['TrafoChat'],
  [FeatureFlag.IncludeAllCitations]: ['TrafoChat'],
  [FeatureFlag.RemarkMath]: ['TrafoChat', 'unstructured'],
  [FeatureFlag.RichReferences]: ['TrafoChat']
}

export const agentHasFeature = (featureFlag: FeatureFlag, agent?: string): boolean => {
  if (!agent) {
    return false
  }

  const hasFeature = agentFeatureFlags[featureFlag].some(
    supportedAgent => supportedAgent.trim().toLowerCase() === agent.trim().toLowerCase()
  )

  return hasFeature
}
